import { render, staticRenderFns } from "./activity_system.vue?vue&type=template&id=b3012918&"
import script from "./activity_system.vue?vue&type=script&lang=js&"
export * from "./activity_system.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports